var _path, _path2, _path3, _path4, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9095_5634)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9095_5634",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9095_5634)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9095_5634",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9095_5634)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_9095_5634",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_9095_5634)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_9095_5634",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_9095_5634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0H4C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H20C22.2091 24 24 22.2091 24 20V4C24 1.79086 22.2091 0 20 0Z",
    fill: "#CurrentColor"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9095_5634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5591 18.6903C10.7653 20.4441 7.88122 20.4371 6.09748 18.6658C4.31425 16.8955 4.30722 14.031 6.07348 12.2497L6.072 12.2487L12.5601 5.80613L13.3715 5.00072C14.7153 3.66641 16.8935 3.66641 18.2373 5.00072C19.5811 6.33503 19.5811 8.49823 18.2373 9.83305L11.0853 16.8611L11.0828 16.8591C10.2014 17.7029 8.7966 17.6969 7.92573 16.8366C7.05485 15.9757 7.04936 14.5879 7.90322 13.718L7.9007 13.715L8.69708 12.9291L12.679 8.99617L13.4749 9.78307L8.69708 14.5019C8.25713 14.9358 8.25713 15.6402 8.69708 16.0746C9.13704 16.5091 9.85041 16.5091 10.2898 16.0746L17.4263 9.02662L17.4243 9.02513L17.4513 9.00211C18.3472 8.11272 18.3472 6.66993 17.4513 5.78059C16.5554 4.89126 15.1037 4.89121 14.2078 5.78059L14.1838 5.80762L14.1823 5.80659L13.3714 6.61148L6.88289 13.0541C5.5391 14.3884 5.5391 16.5516 6.88289 17.8859C8.22668 19.2202 10.4054 19.2202 11.7482 17.8859L17.4254 12.2487L18.2363 11.4438L19.0472 12.2487L18.2363 13.0541L12.5601 18.6913L12.5591 18.6903Z",
    fill: "white"
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9095_5634"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9095_5634"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachments);
export default __webpack_public_path__ + "static/media/attachments.6c0334e80a9b8772439815f6e0d79475.svg";
export { ForwardRef as ReactComponent };